<!-- Meant for textures and gradiants-->
<script setup lang="ts">

const props = withDefaults(defineProps<{
  id: string,
  divider: {
    transition: {
      mode?: 'out-in' | 'duo'
    },
    divider: {
      type: 'gradient',
      styles: {},
      options: {},
    }
  };
}>(), {
  id: '',
  divider: () => {  
    return {
      transition: {
        mode: 'out-in'
      },
      divider: {
        shape: 'wavy-steps',
        styles: {
          fill: 'white',
        },
        options: {},
      }
    }
  },
})

const divider = computed(() => props.divider.divider);

const dividerStyles = computed(() => {
  return {
    fill: 'white',
  }
})

const shape = computed(() => divider.value?.shape)


</script>

<template>
  <div class="layer layer-dividers" :class="id">

    <!-- <div class="set-test absolute top-0 left-0 w-full h-full z-50 bg-red-500 text-white">
      {{dividerStyles}}
    </div> -->

    <!-- <div class="overlay navigation" /> -->
    <!-- <div class="overlay default-gradient" /> -->
    
    <slot name="dividers" />

    <div class="sec-hero-divider" ">

      <!-- v-if="shape === 'slope-asymmetrical-divider'"-->
      <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" :style="dividerStyles" preserveAspectRatio="none"><path d="M0 0v4l594.5 84a1118.6 1118.6 0 0 0 311 0l94.5-13.3V0H0Z"></path></svg>

      

      <!-- v-else-if="shape === 'wavy-steps'" -->

      <!-- Wavy Steps-->
      <!-- <svg 
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" 
      :style="dividerStyles" preserveAspectRatio="none"><path d="M0 0v90.2C49.7 99.9 105 82 160 65c75.5-23.3 145.5-22.4 222-3 63 16 119 14 173-8 79.5-32.4 156.2-27.6 240-10 82.6 17.4 143-1 205-31.7V0H0Z"></path></svg> -->
    </div>

  </div>
</template>


<style lang="scss" scoped>

.layer-dividers {
  position: relative;

  .sec-hero-divider {
    width: 100%;
    height: 100%;
    position: absolute;
    top: auto;
    bottom:0;
    left:0;

    transform: rotate(180deg) scaleX(-1);
    
    svg {
      height: 60px;
      width:100%;

      position: relative;
      bottom: 1px;
    }

    
  }
}
</style>